export default __webpack_public_path__ + "static/media/loadingPNG.30f24351.jpg";